import { useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const useDialog = (queryKey, uniqueDialogName, options={ params: {} }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const dynamicParams = useRef(null)
  const navigate = useNavigate()
  const isOpen = searchParams.has(queryKey, uniqueDialogName)

  const modifyParams = (params, action) => {
    if (!params) return false;
    const paramKeys = Object.keys(params)
    if (paramKeys.length > 0) {
      paramKeys.forEach((key) => {
        searchParams[action](key, params[key])
      })
    }
    
    return paramKeys.length > 0
  }

  const openDialog = (newDynamicParams, navigateOptions) => {
    searchParams.set(queryKey, uniqueDialogName)
    // Sets static params defined during initial hook call
    modifyParams(options.params, 'set')
    // Sets dynamic params defined during call to open dialog
    
    // Check that params exist, and that params are NOT an event passed by mistake, and that they can be parsed into key/values
    if (
      newDynamicParams 
      && newDynamicParams?.constructor?.name !== 'SyntheticBaseEvent' 
      && Object.keys(newDynamicParams).length > 0
    ) {
      modifyParams(newDynamicParams, 'set')
      dynamicParams.current = newDynamicParams
    }
    // Sets updated search prams
    setSearchParams(searchParams, navigateOptions)
  }
  
  const closeDialog = (closeOptions={}) => {
    if (closeOptions.useStrictNavigation) {
      searchParams.delete(queryKey, uniqueDialogName)
      // Deletes static params defined during initial hook call
      modifyParams(options.params, 'delete')
      // Deletes dynamic params defined during call to open dialog
      if (dynamicParams.current) {
        modifyParams(dynamicParams.current, 'delete')
        dynamicParams.current = null
      }
      // Sets updated search prams
      setSearchParams(searchParams, { replace: !!closeOptions.replace })
    } else {
      // NOTE: For now we're preferring this method of going back
      //       because setting the params to what they were before
      //       messes up back navigation when the component that
      //       generated the modal is gone.
      dynamicParams.current = null
      navigate(-1)
    }
  }

  return [
    isOpen,
    openDialog,
    closeDialog,
  ]
}

export default useDialog
